import { ColumnScheduleModel, GroupScheduleModel } from "countable@model";

export class AddScheduleModel {
  acctYear: number = null;
  engId: number = null;
  columns: ColumnScheduleModel[] = [];
  groupName: string = null;
  isCollapse: boolean = false;
  isManual: boolean = false;
  schedules: GroupScheduleModel[] = [];
  sortOrder: number = null;
  submoduleId: number = null;
}

